module.exports = __webpack_public_path__ + "static/media/accessories-6.c4e0fc2b.jpg";